<template>
  <div class="RequestedOfferCardContainer">
    <HotOfferCard
      v-bind="$attrs"
      :tag-type="cptdOfferTag.type"
      :tag-label="cptdOfferTag.label"
      :interest-rate="
        offer.display_interest_rate_monthly || offer.interest_rate_monthly || 0
      "
      :installment-value="offer.installment_amount"
      :duration="offer.duration"
      :amount="offer.amount"
      :partner="offer.partner"
      @action-forward-click="redirectUser"
      @brand-click="redirectUser"
      @offer-conditions-click="redirectUser"
    />
    <slot name="modal" />
  </div>
</template>
<script>
import { UIFeedbackTypes } from '@/helpers/offer-types'
import { OfferStatus, OfferSubStatus } from '@/data/common'
import HotOfferCard from '~/aasgard/components/cards/HotOfferCard.vue'
export default {
  name: 'RequestedOfferCardContainer',
  components: {
    HotOfferCard,
  },
  props: {
    offer: { type: Object, required: true },
  },
  data() {
    return {
      OfferSubStatusMessagesEnum: {
        UNKNOWN_OFFER_SUB_STATUS: 'Aguardando resposta da parceira',
        AGREEMENT_ACCEPTED: 'Oferta solicitada',
        WAITING_FOR_VALIDATION: 'Aguardando resposta da parceira',
        SUBMITTED_FOR_SELECTION: 'Aguardando resposta da parceira',
        SELECTED: 'Aguardando enviar documentos',
        WAITING_FOR_DATA: 'Aguardando enviar documentos',
        WAITING_FOR_DOCUMENT_UPLOADS: 'Aguardando enviar documentos',
        WAITING_FOR_AGREEMENT_ACCEPTANCE: 'Aguardando enviar documentos',
        INFORMATION_INCORRECT: 'Problema nos dados enviados',
        PROBLEM_WITH_DOCUMENT: 'Problema nos documentos enviados',
      },
      OfferSubStatusUIFeedbackEnum: {
        UNKNOWN_OFFER_SUB_STATUS: 'NEUTRAL',
        WAITING_FOR_VALIDATION: 'NEUTRAL',
        SUBMITTED_FOR_SELECTION: 'NEUTRAL',
        SELECTED: 'POSITIVE-LIGHT',
        WAITING_FOR_DATA: 'POSITIVE-LIGHT',
        WAITING_FOR_DOCUMENT_UPLOADS: 'POSITIVE-LIGHT',
        WAITING_FOR_AGREEMENT_ACCEPTANCE: 'POSITIVE-LIGHT',
        AGREEMENT_ACCEPTED: 'POSITIVE-LIGHT',
        INFORMATION_INCORRECT: 'ERROR',
        PROBLEM_WITH_DOCUMENT: 'ERROR',
      },
    }
  },
  computed: {
    cptdOfferTag() {
      switch (this.offer.status) {
        case OfferStatus.ONGOING:
          return {
            label: this.OfferSubStatusMessagesEnum[this.offer.sub_status],
            type: UIFeedbackTypes[
              this.OfferSubStatusUIFeedbackEnum[this.offer.sub_status]
            ],
          }
        default:
          return null
      }
    },
    cptdLblRedirectButton() {
      const { sub_status } = this.offer
      const lblDefault = 'Oferta solicitada'

      switch (sub_status) {
        case OfferSubStatus.UNKNOWN_OFFER_SUB_STATUS:
        case OfferSubStatus.SUBMITTED_FOR_SELECTION:
        case OfferSubStatus.PROBLEM_WITH_DOCUMENT:
        case OfferSubStatus.INFORMATION_INCORRECT:
          return 'Oferta solicitada'
        case OfferSubStatus.WAITING_FOR_DOCUMENT_UPLOADS:
          return 'Enviar documentos'
        case OfferSubStatus.WAITING_FOR_AGREEMENT_ACCEPTANCE:
          return 'Assinar contrato'
        case OfferSubStatus.SELECTED:
        case OfferSubStatus.WAITING_FOR_DATA:
          return 'Continuar'
        default:
          return lblDefault
      }
    },
    cptdButtonDisabled() {
      const { sub_status } = this.offer
      switch (sub_status) {
        case OfferSubStatus.WAITING_FOR_DOCUMENT_UPLOADS:
        case OfferSubStatus.SELECTED:
        case OfferSubStatus.WAITING_FOR_DATA:
        case OfferSubStatus.WAITING_FOR_AGREEMENT_ACCEPTANCE:
          return false
        default:
          return true
      }
    },
    cptdRedirectOfferLink() {
      const { product_type, offer_id, partner } = this.offer
      const product = product_type === 'auto' ? 'auto' : 'sem-garantia'

      switch (this.offer.sub_status) {
        case OfferSubStatus.SELECTED:
        case OfferSubStatus.WAITING_FOR_DATA:
        case OfferSubStatus.PROBLEM_WITH_DOCUMENT:
        case OfferSubStatus.WAITING_FOR_DOCUMENT_UPLOADS:
        case OfferSubStatus.WAITING_FOR_AGREEMENT_ACCEPTANCE:
          return `/contratacao/${product}/${partner.toLowerCase()}/${offer_id}`
        // TODO: [CROSS SQUAD] SEE HOW WE WILL THREAT INFORMATION_INCORRECT
        // MAYBE USE THE WHATSAPP APPROACH?
        // case OfferSubStatus.INFORMATION_INCORRECT:
        default:
          return ''
      }
    },
  },
  methods: {
    redirectUser() {
      if (this.cptdRedirectOfferLink) {
        this.$router.push({
          path: this.cptdRedirectOfferLink,
        })
      }
    },
  },
}
</script>
<style lang="scss"></style>
